import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { Accounts } from '../../containers/account/Accounts';

export const AdminAccountsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<Accounts />
		</AdminDashboardPageLayout>
	);
};
